export {}

const generateGalleryId = (gallerySelector: string, galleryLinkSelector: string) => {
  const galleries = document.querySelectorAll(gallerySelector)
  const galleryId = `post-gallery`

  galleries.forEach((gallery) => {
    const links = gallery.querySelectorAll(galleryLinkSelector)

    links.forEach((link) => {
      const image = link.querySelector<HTMLImageElement>('img')

      link.setAttribute("data-fancybox", galleryId)
      if (image && image.dataset.src) link.setAttribute("data-thumb", image.dataset.src)
    })
  })
}

generateGalleryId(".gallery", ".gallery-icon a")
generateGalleryId(".wp-block-gallery", ".blocks-gallery-item a")
